import ky from 'ky'
import {
  TAccount,
  TAppAuthPayload,
  TVerifyCredentialsResult,
} from 'shopify-payments-types'

export const AUTH_TOKEN_KEY = 'token'

export function createApi() {
  const api = ky.extend({
    prefixUrl: '/app',
    mode: 'cors',
    hooks: {
      beforeRequest: [
        (request) => {
          const token = window.sessionStorage.getItem(AUTH_TOKEN_KEY) || null
          if (token) {
            request.headers.set('x-token', token)
          }
        },
      ],
    },
  })

  return {
    async authenticate() {
      return api.get(`auth${window.location.search}`).json<TAppAuthPayload>()
    },
    readAccount() {
      return api.get('account').json<{ account: TAccount | null }>()
    },
    verifyCredentials(credentials: Dictionary, testMode: boolean = false) {
      return api
        .post('verifyCredentials', {
          json: { credentials, isTest: testMode },
        })
        .json<TVerifyCredentialsResult>()
    },
    async saveConfig(config: Dictionary) {
      await api.post('saveConfig', { json: config })
    },
    async registerComGate(config: Dictionary) {
      await api.post('registerComGate', { json: config })
    },
    activateAccount() {
      return api
        .post('activateAccount')
        .json<{ success: boolean; redirectUrl: string }>()
    },
    deactivateAccount() {
      return api
        .post('deactivateAccount')
        .json<{ success: boolean; account: TAccount | null }>()
    },
  }
}

export type TApi = ReturnType<typeof createApi>
